import React from 'react'

export default function ConfigureProviderPolicy() {
  const data:any = [
    {Activity: '40', Benifit: 'A',status:"Accepted"},
    {Activity: '40', Benifit: 'B',status:"Rejected"},
    {Activity: '40', Benifit:'B',status:"other Configuration"},
    {},

  ];
  return (
    <div className=' container'style={{margin:"30px"}} >
      {/* title */}
<h5>Configure Provider Policy Screen <span>  <i className="fa-regular fa-newspaper"></i> </span>   </h5>
{/* first row input */}
<div className=' row'>
<div className="input-group w-50  m-3">
  <input type="file" className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload"/>
  
  <button className="btn btn-secondary" type="submit"  style={{marginLeft:"10px", padding:"8px"}}> <span className=' m-1 '><i className="fa-solid fa-upload"></i></span>Upload</button>
</div>

</div>
{/* second row input */}

<div className=' row d-flex flex-row w-100 ' style={{ marginTop:"20px"}}>
 <select name="providerName" id=""className='  p-1 ' style={{marginLeft:"7px",width:"25%"}}>
  

<option value="providerName">Provider Name</option>

 </select>
 <select name="ActivityName" id=""className='  p-1 ' style={{marginLeft:"7px",width:"25%"}}>
  

  <option value="ActivityName">Activity Name</option>
  
   </select>
   <select name="BenifitGroup" id=""className='  p-1 ' style={{marginLeft:"7px",width:"25%"}}>
  

  <option value="BenifitGroup">Benifit Group</option>
  
   </select>
   <input type="text" className="form-control " placeholder="Search "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>




</div>

{/* table */}
<table style={{  width: '100%' , marginTop:"40px" }}>
      <thead>
        <tr>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}></th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>Activity</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>Benifit Group</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>Discount</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>Provider Name</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }} className=' text-center'>Status</th>

        </tr>
      </thead>
      <tbody>
        {data.map((item:any,index:number) => (
          <tr key={item.id} className=' text-center' style={{
            background: index % 2 === 0 ? '#74C0FC' : '#ffffff', 
            border: '1px solid #ddd',
            padding: '8px',
          }}>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}><input type="checkbox" id="Remmber" /> </td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.Activity}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.Benifit}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.status}</td>
          </tr>
          
        ))}
      </tbody>
    </table>
    {/* last row input */}
    <div className="row d-flex justify-content-end m-4">
    <button className="btn btn-danger w-25" type="submit"  style={{padding:"5px"}}> <span className=' m-2'><i className="fa-solid fa-circle-check"></i></span>Configure</button>

    </div>
    </div>
  )
}
